References = {
    init: function(PAGE) {
        this.el = $('[page="referencie"]', PAGE || $("body"));
        if (!this.el.length) return;
        this.squares = this.el.find('[block="squares"] a');
        this.texts = this.el.find(".text-position .cell");
        this.content = this.el.find('[block="content"] .text-position');
        this.bind();
    },

    bind: function() {
        this.texts.each(function(index, text) {
            $(this).attr("order", index);
        });
        this.squares.each(function(index, square) {
            $(this).attr("order", index);
            $(this).addClass('not-nav');

            $(this).click(function(event) {
                event.preventDefault();
                References.showSquare($(this).parent('.item'));
            });
        });
    },

    showSquare: function(currentSquare) {

        var order = currentSquare.find('a').attr("order");
        var currentText = this.texts.filter('[order="' + order + '"]');

        currentSquare.addClass("selected");
        currentSquare.siblings('.item').removeClass('selected');

        currentText.addClass("selected");
        currentText.siblings('.selected').removeClass('selected');

        var time = 0;
        var diff = 30;

        if (!References.el.attr('open')) {
            time = 700;
            diff = 0;
        }

        setTimeout(function(){
            References.content.css({
                opacity: 1,
                left: currentSquare.position().left - diff
            });
        }, time)
        
        this.el.attr('open','');

    },
};
